import { confirmSignIn } from "aws-amplify/auth";
import React, { FormEvent, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { meetsPasswordRequirements } from "../../../helper/password-requirements";
import VelavuButton from "../../../elements/velavu-button";
import VelavuInput from "../../../elements/velavu-input";
import VelavuNotice from "../../../elements/velavu-notice/velavu-notice";
import AuthenticationButtonBar from "../authentication-button-bar";
import * as onboardingStyles from "../authentication.module.scss";

export default function Challenge() {
	const { t } = useTranslation();

	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const [errorText, setErrorText] = useState<string | undefined>(undefined);

	const [isLoading, setLoading] = useState(false);

	const inputValid =
		meetsPasswordRequirements(password) && password === confirmPassword;

	const submitChallenge = useCallback(
		(event: FormEvent<HTMLFormElement>) => {
			event.preventDefault();

			//Ignoring if the user hasn't properly completed the form
			if (!inputValid) return;

			setLoading(true);

			confirmSignIn({
				challengeResponse: password,
			})
				.then((user) => {})
				.catch((error) => {
					setErrorText(error.message);
					setLoading(false);
				});
		},
		[inputValid, setLoading, password, setErrorText],
	);

	return (
		<form onSubmit={submitChallenge}>
			<p className={onboardingStyles.instructionsText}>
				{t("auth.challenge.title")}
			</p>

			<VelavuInput
				value={password}
				onChange={setPassword}
				placeholder={t("auth.challenge.password_placeholder")}
				type="password"
				autoComplete="new-password"
				disabled={isLoading}
				fullWidth
				bottomPadding
			/>
			<VelavuInput
				value={confirmPassword}
				onChange={setConfirmPassword}
				placeholder={t("auth.challenge.confirm_password_placeholder")}
				type="password"
				autoComplete="new-password"
				disabled={isLoading}
				fullWidth
				bottomPadding
			/>

			{errorText ? (
				<VelavuNotice
					className={onboardingStyles.noticeMargin}
					type="error"
				>
					{errorText}
				</VelavuNotice>
			) : (
				<VelavuNotice
					className={onboardingStyles.noticeMargin}
					type="info"
				>
					{t("password_requirements")}
				</VelavuNotice>
			)}

			<AuthenticationButtonBar
				primary={
					<VelavuButton
						label={t("auth.challenge.update_button")}
						disabled={isLoading || !inputValid}
						fullWidth
						submit
					/>
				}
			/>
		</form>
	);
}
